export const ORDERS_STATS_EVENTS = {
  ORDERS_STATS_AMOUNT: 'orders-stats-amount',
  ORDERS_STATS_COUNT: 'orders-stats-count',
  ORDERS_STATS_EARNINGS: 'orders-stats-earnings',
};

export const ORDERS_PRODUCT_FILTER_EVENTS = {
  ORDERS_PRODUCT_FILTER_ALL: 'orders-filter-product-all',
  ORDERS_PRODUCT_FILTER_OSAGO: 'orders-filter-product-osago',
  ORDERS_PRODUCT_FILTER_GREEN_CARD: 'orders-filter-product-green-card',
  ORDERS_PRODUCT_FILTER_TOURISM: 'orders-filter-product-tourism',
  ORDERS_PRODUCT_FILTER_HOME: 'orders-filter-product-home',
  ORDERS_PRODUCT_FILTER_EXTERNAL: 'orders-filter-product-external',
  ORDERS_PRODUCT_FILTER_MINI_KASKO: 'orders-filter-product-mini-kasko',
  ORDERS_PRODUCT_FILTER_PETS: 'orders-filter-product-pets',
};

export const ORDERS_PARTNER_FILTER_EVENTS = {
  ORDERS_PARTNER_FILTER_ALL: 'orders-filter-partner-all',
  ORDERS_PARTNER_FILTER_MAIN: 'orders-filter-partner-main',
};

export const ORDERS_PERIOD_FILTER_EVENTS = {
  ORDERS_PERIOD_FILTER_LAST_12_MONTHS: 'orders-filter-period-last-12-months',
  ORDERS_PERIOD_FILTER_MONTH: 'orders-filter-period-month',
  ORDERS_PERIOD_FILTER_WEEK: 'orders-filter-period-week',
  ORDERS_PERIOD_FILTER_DAY: 'orders-filter-period-day',
  ORDERS_PERIOD_FILTER_DATES_RANGE: 'orders-filter-period-dates-range',
};
